import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
  manageContainer:{
    '&>:first-child':{
      marginTop: 10,
    }
  },
  testIcon: {
    padding: '0 0 0 10px'
  },
  requestDialogTitle: {
    fontWeight: 600,
    fontSize: 20,
    lineHeight: "33px",
    color: "#333333",
  },
    dialogBox: {
        marginTop: '12px'
    },
    linkCTA:{
        color: '#1d7dea',
        marginRight: 10,
        cursor: 'pointer'
    },
    root: {
        '&>:first-child':{
            '&>:first-child':{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: "nowrap",
                flexDirection: "initial",
                marginBottom: 15,
            }
        },
        '& $label':{
            '&>:nth-child(2)':{
                fontSize: 15,
                fontWeight: 400,
                color: '#333'
            }
        }
    },
    header: {
        margin: 'auto'
    },
    line: {
        borderTop: '1px solid #DCDCDC'
    },
    button: {
        marginLeft: '435px'
    },
    scheduleTest: {

    },
    division: {
        margin: '25px'
    },
    colorRed: {
        color: 'red'
    },
    border: {
        borderRadius: '12px'
    },
    marginSpan: {
        marginLeft: '90px'
    },
    marginDiv: {
        marginLeft: '176px'
    },
    buttonMiddle: {
        marginLeft: '212px'
    },
    // Upload milestone
    dragDropVideoCustome:{
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
        '&>:first-child':{
            '&>:first-child':{
                border: "1px dashed #D8D8D8",
                padding: "15px",
                textAlign: "center",
                borderRadius: "4px",
                width: "100%",
                margin: '30px 0 18px 0'
            }
        }
    },
    dragDropVideoContainer: {
        border: "2px dashed #D8D8D8",
        padding: "15px",
        textAlign: "center",
        borderRadius: "4px",
        width: "100%",
        margin: '30px 0 18px 0'
      },
      dragDropVideoText: {
        color: "#333",
        fontSize: "14px",
        fontWeight: 700,
        display: "inline-block",
      },
      fileInfo:{
        fontSize: 12,
        lineHeight: '16px',
        color: '#999',
        display: 'block',
        fontWeight: 'normal'
      },
      fileTypeInfo:{
        fontSize: 14,
        fontWeight: 600,
        color: '#666',
        textAlign: 'center'
      },
      downloadSample:{
        fontSize: 14,
        fontWeight: 600,
        color: '#1d7dea',
        textAlign: 'center',
        marginTop: 15,
        marginBottom: 20,
        cursor: 'pointer'
      },
      customSelect: {
        "& > div:nth-of-type(1)": {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          height: '38px',
          padding: 0,
        },
      },
      testRadioGroup:{
        '& $label':{
          '&>:nth-child(2)':{
            fontSize: 15,
            fontWeight: 400,
            color: '#333'
          }
        }
      },
      uploadPreview:{
        '&>:first-child':{
          justifyContent: 'center',
          '&>:first-child':{
            '&>:first-child':{
              margin: '16px 0'
            }
          }
        }
      },
      inputLable:{
        fontSize: 16,
        color: '#666',
        marginBottom: 10,
        fontWeight: 600,
        display: 'inline-block',
        textTransform: 'capitalize',
      },
      mt15:{
        marginTop: 15,
      },
    //   add schedule test
    customTime:{
      // marginTop:15,
      marginBottom:15,
      '&:hover':{
        cursor: 'pointer',
      },
      '& input':{
        border: "1px solid #DFDFDF",
        borderRadius:4,
        height: '44px',
        '&:hover':{
          cursor: 'pointer',
        },
      }
    },
    customTextField:{
        
    },
    manageField:{
        

    },
    dialogCustomSelect: {
      '&>div:nth-of-type(1)':{
        minWidth: '100% !important',
      }
    },
    dialogCustomInput:{
      '&>div:nth-of-type(1)':{
        marginTop: 0,
      }
    },
    titleCapital:{
      textTransform: 'capitalize',
      marginBottom: 5,
    },
    transitionCSS: {
      // "&>:last-of-type": {
        "& .searchTransition": {
          "& .optionContainer": {
            left: 0,
            width: "100%",
            bottom: 64,
          },
          "&>:nth-child(2)": {
            "&:after": {
              top: -73,
              transform: "rotate(44deg)!important",
            },
          },
        },
        "& .calenderTransition": {
          "&>:first-child": {
            width: '100%!important',
            "& .rdrCalendarWrapper": {
              border: "1px solid #ddd",
              boxShadow: "1px 1px 1px #ddd",
              background: "#fff",
              borderRadius: 4,
              bottom: "46px!important",
              top: "initial!important",
            },
          },
        // },
      },
    },
    inputCont:{
      '&>div:nth-of-type(1)':{
        width: '100%',
        '&> div':{
          '& input':{
            paddingLeft: 30,
          }
        }
      }
    },
    dialogSelect:{
      '&>div:nth-of-type(1)':{
        width: '100%',
      }
    },
    customInput:{
      display: 'initial!important',
      marginTop: 10,
      position: 'relative',
      '&>:nth-child(2)':{
          marginTop: 0,
          width: '100%',
          '&>:first-child':{
            height: 44,
        }
      },
      '&>span':{
        position: "absolute",
        right: 15,
        top: 52,
        color: "#999",
        zIndex: 1,
      }
    },
    searchBarChips:{
      height: 'auto',
      '&>div:nth-of-type(1)':{
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: '0 0 0 15px',
        '&>div:nth-of-type(1)':{
          '&>div:nth-of-type(1)':{
            '&>div:nth-of-type(1)':{
              '&>div:nth-of-type(1)':{
                overflow: 'initial',
                '&>div:last-of-type':{
                  marginTop: 'initial !important',
                  lineHeight: '30px',
                }
              }
            }
          }
        }
      },
      '& svg':{
        cursor: 'pointer'
      }
    },
    customGrid:{
      display: "grid",
      gridTemplateColumns: "50% 50%",
      '& > div':{
        flexBasis: '100%',
        maxWidth: '100%',
        '&:nth-of-type(1)':{
          marginRight: 10,
        },
        '&:nth-of-type(3)':{
          marginRight: 10,
        },
      }
    },
    removeEndDate: {
      position: 'absolute',
      right: 18,
      marginTop: 7,
      textDecoration: 'none',
      color: '#1D7DEA',
      fontSize: 14,
      fontWeight: 600,
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      '&:disabled': {
        opacity: 0.5,
        cursor: 'default',
      }
    },
});

export { styles };